import { render, staticRenderFns } from "./PostingCardV3.vue?vue&type=template&id=380539e2"
import script from "./PostingCardV3.vue?vue&type=script&lang=ts"
export * from "./PostingCardV3.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('380539e2')) {
      api.createRecord('380539e2', component.options)
    } else {
      api.reload('380539e2', component.options)
    }
    module.hot.accept("./PostingCardV3.vue?vue&type=template&id=380539e2", function () {
      api.rerender('380539e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/recruitings/PostingCardV3.vue"
export default component.exports